<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="1200">
      <custom-modal
        title="Transfer Stock"
        @onSubmit="saveBatch"
        @onClose="cancelBatch"
        :isLoading="isLoading"
      >
        <v-data-table
          :fixed-header="true"
          :headers="columns"
          :items="productList"
          item-key="id"
          disable-pagination
          hide-default-footer
          class="row-pointer product-list"
          expand
          dense
        >
          <template v-slot:top>
            <v-toolbar flat class="pb-6">
              <strong>Warehouse : </strong
              ><v-chip class="ml-4" label>{{
                productList[0].warehouse.name
              }}</v-chip>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <strong>Kitchen : </strong>
              <v-autocomplete
                class="pt-4 pl-4"
                item-text="name"
                item-value="id"
                :items="kitchens"
                :error-messages="kitchenError"
                v-model="slectedKitchen"
                @input="kitchenError = []"
                outlined
                :search-input.sync="searchKitchen"
              >
              </v-autocomplete>
            </v-toolbar>
          </template>

          <template v-slot:item.available="{ item }">
            {{ item.quantity }}
          </template>

          <template v-slot:item.transferedUnitQuantity="{ item }">
            {{ item.transferedUnitQuantity }}
          </template>

          <template v-slot:item.sellingPrice="{ item }">
            {{ item.sellingPrice }}
          </template>

          <template v-slot:item.selectedUnit="{ item }">
            <div class="pl-4 pt-4" style="border-left: 1px solid">
              <v-select
                item-text="name"
                item-value="id"
                :items="item.product.units"
                v-model="item.selectedUnit"
                outlined
                dense
                @change="getAvailableConvertableQty(item)"
              >
              </v-select>
            </div>
          </template>

          <template
            v-slot:item.actual_stock="{ item }"
            style="border-left: 1px solid"
            >{{ actual_stock }}
            <v-text-field
              v-model="item.actual_stock"
              :max="item.quantity"
              type="number"
              required
              v-bind="attrs"
              v-on="on"
              :error-messages="item.quantityMaxErrorMessages"
              dense
              class="pt-3"
              outlined
              min="0"
              @input="getAvailableConvertableQty(item)"
            ></v-text-field>
          </template>
          <template v-slot:item.newSellingPrice="{ item }">
            <v-text-field
              v-model="item.newSellingPrice"
              type="number"
              required
              v-bind="attrs"
              v-on="on"
              dense
              class="pt-3"
              outlined
              min="0"
            ></v-text-field>
          </template>
        </v-data-table>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "@/plugins/axios";

import { ProductBatch } from "../../../models/ProductBatch";
import datePickComponent from "../../../components/base/DateComponent";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import * as moment from "moment/moment";

export default {
  data: () => ({
    units: [],
    slectedKitchen: null,
    kitchens: [],
    searchKitchen: null,
    kitchenError: [],
    kitchenLoading: false,
    columns: [
      {
        text: "Product Name",
        value: "product.name",
        show: true,
        disabled: true,
        align: "left",
        width: "14.2%",
      },
      {
        text: "Batch Name",
        value: "batch.batch",
        show: true,
        disabled: true,
        align: "left",
        width: "12%",
      },
      {
        text: "Unit",
        value: "unit.name",
        align: "center",
        show: true,
        disabled: false,
        width: "10%",
      },
      {
        text: "Available stock",
        value: "available",
        show: true,
        disabled: false,
        align: "center",
        width: "10%",
      },
      {
        text: "Transfer Qty",
        value: "actual_stock",
        show: true,
        disabled: false,
        align: "center",
        width: "10%",
      },

      {
        text: "Transfering unit",
        value: "selectedUnit",
        show: true,
        disabled: false,
        align: "center",
        width: "14%",
      },
      {
        text: "Qty",
        value: "transferedUnitQuantity",
        show: true,
        disabled: false,
        align: "center",
        width: "10%",
      },
      {
        text: "Original selling price",
        value: "sellingPrice",
        show: true,
        disabled: false,
        align: "right",
        width: "10%",
      },
      {
        text: "Selling Price",
        value: "newSellingPrice",
        show: true,
        disabled: false,
        align: "right",
        width: "14%",
      },
    ],
    dialog: false,
    show: false,

    isLoading: false,
  }),

  name: "AddBatch",
  updated: function () {
    console.log(this.visible);
  },
  props: {
    productList: {
      type: Array,
      default: [],
    },
  },
  components: { ValidationProvider, ValidationObserver, datePickComponent },
  watch: {
    searchKitchen(value) {
      if (!value) {
        this.getKitchensByQuery("");
      }
      this.getKitchensByQuery(value);
    },
  },
  created() {
    this.getKitchensByQuery("");
    this.getAllUnits();
  },
  methods: {
    updateBarcode(value) {},
    openModal() {
      this.show = true;
    },
    checkQuantityMaximum(item) {
      item.quantityMaxErrorMessages = [];
      if (item.quantity > item.maxStock) {
        item.quantityMaxErrorMessages.push(`max Quantity is ${item.maxStock}`);
      }
    },
    cancelBatch() {
      this.show = false;
      this.$emit("conform", "");
    },
    async checkBarcode(unit) {
      let result = await this.checkBarcodeDuplicate(unit.barcode);
      if (result == true) {
        unit.barcodeError = [];
        unit.barcodeError.push("Duplicate Barcode Found");
      }
    },
    getKitchensByQuery(query = "") {
      this.kitchenLoading = true;
      this.$store
        .dispatch("warehouse/GetKitchens", { query: query })
        .then((res) => {
          console.log("SSSHHHHOOPPPPP", res);
          this.kitchens = res;
          this.kitchenLoading = false;
        })
        .catch((err) => {
          this.kitchenLoading = false;
          this.messages = err.data.name;
        });
    },

    getAvailableConvertableQty(item) {
      axios
        .get(
          `hms/products/${item.product.id}?batch=${item.batch.id}&unit=${item.selectedUnit}&quantity=${item.actual_stock}`
        )
        .then((resp) => {
          console.log("resp.data", resp.data.data);
          item.transferedUnitQuantity = resp.data.quantity;
          item.newSellingPrice = resp.data.amount;
          item.sellingPrice = resp.data.amount;
        })
        .catch((err) => {
          item.transferedUnitQuantity = item.quantity;
        });
    },

    async saveBatch() {
    
      let error = false;
      if (!this.slectedKitchen) {
        error = true;
        this.kitchenError = [];
        this.kitchenError.push("Kitchen is required");
      }
      for (let u of this.productList) {
        if (u && u.quantity <= 0) {
          error = true;
          u.quantityMaxErrorMessages = [];
          u.quantityMaxErrorMessages.push("quantity should be greater than 0");
        } else if (u && parseInt(u.actual_stock) > parseInt(u.maxStock)) {
          error = true;
          u.quantityMaxErrorMessages = [];
          u.quantityMaxErrorMessages.push(
            `Transfer Quantity Should be less than ${u.maxStock}`
          );
        } else {
          u.quantityMaxErrorMessages = [];
        }
      }
      if (!error) {
        let Credentials = new Object();
        Credentials.date = moment().format("YYYY-MM-DD");
        Credentials.remarks = "remarks";
        Credentials.warehouse_id = this.productList[0].warehouse.id;

        Credentials.kitchen_id = this.slectedKitchen;
        Credentials.items = [];
        this.productList.map((p) => {
          let item = new Object();
          item.product_id = p.product.id;
          item.batch_id = p.batch.id;
          item.unit_id = p.unit.id;
          item.quantity = p.actual_stock;
          item.transfer_unit_id = p.selectedUnit;
          item.amount = p.newSellingPrice;
          item.transfer_quantity = p.transferedUnitQuantity;
          Credentials.items.push(item);
        });
        // this.$store
        //   .dispatch("product/TranferProductToKitchenFromWarehouse", Credentials)
        //   .then((res) => {
        //     this.$toast.success("Product transfered successfully");
        //     this.$router.push("/stock-transfer");
        //   })
        //   .catch((err) => {});
  this.isLoading = true;
        axios
          .post(`hms/transfers`, Credentials)
          .then((resp) => {
            this.succeeed = true;
            this.isLoading = false;
            this.$toast.success("Transfer successfully created");

            this.$emit("success", true);
            this.show = false;
            this.$router.push("/stock-transfer");
          })
          .catch((err) => {
            this.isLoading = false;
            this.$refs.observer.setErrors(err.data.error);

            this.$toast.error("Stock transfer created  failed!");
            this.isLoading = false;
          });
      }
    },
    getAllUnits() {
      this.kitchenLoading = true;
      this.$store
        .dispatch("product/GetAllUnits", null)
        .then((res) => {
          this.units = res;
        })
        .catch((err) => {
          this.kitchenLoading = false;
          this.messages = err.data.name;
        });
    },
  },
};
</script>
